<template>
<div id="info-popup">
  <div class="row">
    <div class="col-12 paragraph14 title">{{  data ? data : this.$t('app.verification_questions.no_legal_reference') }}</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'LegalInfoPopUp',
  props: {
    data: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
#info-popup {
  .title {
    color: var(--main-color);
    padding-bottom: 4px;
    font-weight: 500;
    line-height: 1.21;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/LegalInfoPopUp.vue